import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { TooltipComponent } from './';

@NgModule({
    declarations: [TooltipComponent],
    imports: [IonicModule],
    exports: [TooltipComponent]
})
export class TooltipComponentModule {}



// WEBPACK FOOTER //
// ./src/components/core/tooltip/index.module.ts